import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingCreateSport: false,
  loadingDeleteSport: false,
  loadingCreateLeague: false,
  loadingCreateEvent: false,
  loadingCreateMarket: false,
  loadingUploadImage: false,
  loadingUpdateResultSelection: false,
  loadingUpdateFlag: false,
  loadingSyncFlagUrls: false,
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    LOAD_CREATE_SPORT: (s, data) => (s.loadingCreateSport = data),
    LOAD_DELETE_SPORT: (s, data) => (s.loadingDeleteSport = data),
    LOAD_CREATE_LEAGUE: (s, data) => (s.loadingCreateLeague = data),
    LOAD_CREATE_EVENT: (s, data) => (s.loadingCreateEvent = data),
    LOAD_CREATE_MARKET: (s, data) => (s.loadingCreateMarket = data),
    LOAD_UPLOAD_IMAGE: (s, data) => (s.loadingUploadImage = data),
    LOAD_UPLOAD_RESULT: (s, data) => (s.loadingUpdateResultSelection = data),
    LOAD_UPDATE_FLAG: (s, data) => (s.loadingUpdateFlag = data),
    LOAD_SYNC_FLAG_URLS: (s, data) => (s.loadingSyncFlagUrls = data),
  },

  actions: {
    async createSport({ commit }, params) {
      commit("LOAD_CREATE_SPORT", true);
      try {
        const res = await this.$api.post("/v1/portal/sports", params);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_SPORT", false);
      }
    },
    async deleteSport({ commit }, sportid) {
      commit("LOAD_DELETE_SPORT", true);
      try {
        const res = await this.$api.delete(`/v1/portal/sports/${sportid}`);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DELETE_SPORT", false);
      }
    },
    async createLeague({ commit }, params) {
      commit("LOAD_CREATE_LEAGUE", true);
      try {
        const { sportId, ...rest } = params;
        const res = await this.$api.post(
          `/v1/portal/sports/${sportId}/league`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_LEAGUE", false);
      }
    },
    async udpdateLeague({ commit }, params) {
      commit("LOAD_CREATE_LEAGUE", true);
      try {
        const { id, ...rest } = params;
        const res = await this.$api.put(
          `/v1/portal/sports/${params.sportId}/league/${id}`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_LEAGUE", false);
      }
    },
    async deleteLeague({ commit }, id) {
      commit("LOAD_CREATE_LEAGUE", true);
      try {
        const res = await this.$api.delete(`/v1/portal/sports/leagues/${id}`);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_LEAGUE", false);
      }
    },
    async createEvent({ commit }, params) {
      commit("LOAD_CREATE_EVENT", true);
      try {
        const res = await this.$api.post("/v1/portal/sport-events", params);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_EVENT", false);
      }
    },
    async updateEvent({ commit }, params) {
      commit("LOAD_CREATE_EVENT", true);
      try {
        const { eventId, ...rest } = params;
        const res = await this.$api.put(
          `/v1/portal/sport-events/${eventId}`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_EVENT", false);
      }
    },
    async createMarket({ commit }, params) {
      commit("LOAD_CREATE_MARKET", true);
      try {
        const res = await this.$api.post(
          `/v1/portal/sport-events/${params.eventId}/markets`,
          params
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_MARKET", false);
      }
    },
    async updateMarket({ commit }, params) {
      commit("LOAD_CREATE_MARKET", true);
      try {
        const res = await this.$api.put(
          `/v1/portal/sport-events/markets/${params.marketId}`,
          params
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CREATE_MARKET", false);
      }
    },
    async uploadImage({ commit }, params) {
      commit("LOAD_UPLOAD_IMAGE", true);
      try {
        const res = await this.$api.post("/v1/portal/resource/upload", params);
        return res.data.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPLOAD_IMAGE", false);
      }
    },
    async addResultManual({ commit }, params) {
      commit("LOAD_UPLOAD_RESULT", true);
      try {
        const res = await this.$api.post(
          "/v1/portal/sport-events/results",
          params
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPLOAD_RESULT", false);
      }
    },
    async recalculateResult({ commit }, eventId) {
      commit("LOAD_UPLOAD_RESULT", true);
      try {
        const res = await this.$api.post(
          `/v1/portal/sport-events/${eventId}/recalculate-result`
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPLOAD_RESULT", false);
      }
    },
    async updateEventFlag({ commit }, params) {
      commit("LOAD_UPDATE_FLAG", true);
      try {
        const { eventId, teamId, ...rest } = params;
        const res = await this.$api.put(
          `/v1/portal/sport-events/${eventId}/teams/${teamId}`,
          rest
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPDATE_FLAG", false);
      }
    },
    async syncSportEventTeamFlagUrls({ commit }, params) {
      commit("LOAD_SYNC_FLAG_URLS", true);
      try {
        const res = await this.$api.post(
          "/v1/portal/sport-events/teams/sync-flag-urls",
          params
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_SYNC_FLAG_URLS", false);
      }
    },
    async addResultSportingManual({ commit }, params) {
      commit("LOAD_UPLOAD_RESULT", true);
      try {
        const res = await this.$api.post(
          "/v1/portal/sport-events/results/sporting",
          params
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPLOAD_RESULT", false);
      }
    },
  },
};
